import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export default function ReceitaStatusObs({ register, setValue, initialData }) {
  return (
    <div>
      <h3 className="text-lg font-semibold text-slate-900 border-b border-slate-200 pb-2 mb-4">Status e Observacoes</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div className="space-y-2">
          <Label className="text-sm font-medium text-slate-700">Status do Pedido</Label>
          <Select onValueChange={(value) => setValue("status", value)} defaultValue={initialData?.status || "Em Produção"}>
            <SelectTrigger data-testid="select-status"><SelectValue placeholder="Selecione o status" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="Em Produção">Em Producao</SelectItem>
              <SelectItem value="Pronto para Entrega">Pronto para Entrega</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="data_receita" className="text-sm font-medium text-slate-700">Data da Receita (validade)</Label>
          <Input id="data_receita" type="date" {...register("data_receita")} data-testid="input-data-receita" />
          <p className="text-xs text-slate-400">A receita expira 365 dias apos esta data</p>
        </div>
      </div>
      <Textarea {...register("observacoes")} placeholder="Observacoes adicionais..." rows={4} data-testid="input-observacoes" />
    </div>
  );
}
